import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ButtonModule } from '@psei/ng/button';
import { PseicDirectivesModule } from './psei-directives/pseic-directives.module';
import { PseiNgCustomModule } from './psei-ng-custom.module';
import { PseicAsyncButtonComponent } from './pseic-async-button/pseic-async-button.component';
import { PseicAttachmentsModule } from './pseic-attachments/pseic-attachments.module';
import { PseicDropdownButtonComponent } from './pseic-dropdown-button/pseic-dropdown-button.component';
import { PseicEditorModule } from './pseic-editor/pseic-editor.module';
import { PseiFiltersModule } from './pseic-filters/psei-filters.module';
import { PseicFormFieldModule } from './pseic-form-field/pseic-form-field.module';
import { PseicLoaderComponent } from './pseic-loader/pseic-loader.component';
import { PseicPhoneModule } from './pseic-phone/pseic-phone.module';
import { PseicTabModule } from './pseic-tab/pseic-tab.module';
import { PseicTableModule } from './pseic-table/pseic-table.module';
import { PseicToasterModule } from './pseic-toaster/pseic-toaster.module';
import { PseicUploadFilesComponent } from './pseic-upload-files/pseic-upload-files.component';
import { PseicSectionModule } from './section-components/pseic-section.module';


@NgModule({
  imports: [
    PseicFormFieldModule,
    PseicTabModule,
    PseicTableModule,
    PseicDirectivesModule,
    PseicFormFieldModule,
    PseicToasterModule,
    CommonModule,
    PseiFiltersModule,
    PseicAttachmentsModule,
    FlexModule,
    PseicPhoneModule,
    PseicEditorModule,
    PseiNgCustomModule,
    PseicSectionModule,
    ButtonModule
  ],
  exports: [
    PseicFormFieldModule,
    PseicTabModule,
    PseicTableModule,
    PseicDirectivesModule,
    PseicToasterModule,
    PseiFiltersModule,
    PseicAttachmentsModule,
    PseicFormFieldModule,
    PseicAsyncButtonComponent,
    PseicLoaderComponent,
    PseicDropdownButtonComponent,
    PseicUploadFilesComponent,
    PseicPhoneModule,
    PseicEditorModule,
    PseicSectionModule
  ],
  declarations: [PseicAsyncButtonComponent, PseicUploadFilesComponent, PseicLoaderComponent, PseicDropdownButtonComponent]
})
export class PpbSharedModule {
}
